<div mat-dialog-content *ngIf="document && document.pages">
  <div *ngFor="let page of document.pages" class="page">
    <img [src]="page.image">

    <div class="page--overlay"></div>
  </div>
</div>

<div mat-dialog-content *ngIf="content">
  <div [innerHTML]="content | safeHtml" class="content"></div>
  <div class="page--overlay"></div>
</div>

<div class="mat-footer flex-container">
  <!-- <div class="flex-cell"></div> -->
  <button mat-button (click)="onNoClick()">Close</button>
</div>
